module.exports = __webpack_public_path__ + "static/media/account.34148d5e.svg";